import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { NURSE_TYPE_THEME } from '../../types/nurse';

interface ModeTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

/**
 * 看護師一覧のモード切替タブ
 * 通常看護師モードと研修看護師モードを切り替える
 */
const ModeTabs: React.FC<ModeTabsProps> = ({ value, onChange }) => {
  return (
    <Tabs
      value={value}
      onChange={onChange}
      variant="fullWidth"
      sx={{
        '& .MuiTab-root': {
          fontWeight: 'bold',
          fontSize: '1rem',
          py: 1.5,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        },
        '& .Mui-selected': {
          color: value === 0 ? '#d81b60' : '#e65100',
        },
        '& .MuiTabs-indicator': {
          backgroundColor: value === 0 ? '#f48fb1' : '#ffb74d',
          height: 3
        }
      }}
    >
      <Tab
        label="看護師検索"
        sx={{
          bgcolor: value === 0 ? NURSE_TYPE_THEME.NORMAL.BACKGROUND : 'transparent',
          '&:hover': {
            bgcolor: value === 0 ? NURSE_TYPE_THEME.NORMAL.BACKGROUND : '#fff5f8',
          }
        }}
      />
      <Tab
        label="研修看護師"
        sx={{
          bgcolor: value === 1 ? NURSE_TYPE_THEME.TRAINING.BACKGROUND : 'transparent',
          '&:hover': {
            bgcolor: value === 1 ? NURSE_TYPE_THEME.TRAINING.BACKGROUND : '#fffde7',
          }
        }}
      />
    </Tabs>
  );
};

export default ModeTabs;